<div class="u-block-ui-wrapper">
    <p-blockUI [blocked]="true">
         <p-progressSpinner class=""></p-progressSpinner>
    </p-blockUI>
   
</div>
